import { workspaceIdAtom } from "atoms/WorkspaceAtoms";
import useAddPageUser from "api/api-hooks/pages/useAddPageUser";
import useTenantUsers from "api/api-hooks/tenantUsers/useTenantUsers";
import { useAtomValue } from "jotai";
import { callFunctionIfExists } from "utils/GeneralUtils";
import { newToastEvent } from "utils/ToastUtil";
import { useMemo, useState } from "react";
import { Alert, Button, FormGroup } from "reactstrap";
import { SelectPicker } from "rsuite";
import PermissionList from "../CRM/PermissionList";
import AppDrawer from "./AppDrawer";
import AppSpinner from "../../elements/AppSpinner";
import useUser from "../../api/api-hooks/auth/useUser";

// TODO: Combine InviteUserDrawer / InvitePageUserDrawer into one component
const InvitePageUserDrawer = ({ open, onClose, onSuccess, page }) => {
  const { pPermissions: permissions } = useUser();
  const workspaceID = useAtomValue(workspaceIdAtom);
  const { users, usersLoading } = useTenantUsers();
  const [userID, setUserID] = useState("");
  const [permission, setPermission] = useState(null);
  const { addPageUser, addingUser, addPageUserError } = useAddPageUser(
    page?.id
  );

  const pageMembers = useMemo(() => {
    if (!page?.Members) return [];

    return page.Members.map((member) => member.PersonID);
  }, [page]);

  const handleUserChange = (val) => setUserID(val);

  const handleClose = () => {
    setUserID("");
    setPermission(null);
    callFunctionIfExists(onClose);
  };

  const handleInviteUser = () => {
    if (!permission || !userID) return;

    addPageUser({
      workspaceID: workspaceID,
      pageID: page.id,
      userID: userID,
      permissionID: permission,
      onSuccess: () => {
        handleClose();
        callFunctionIfExists(onSuccess);
        newToastEvent("success", "Successfully added user");
      },
    });
  };

  const renderMenu = (menu) => {
    if (usersLoading) return <div className="text-center">Loading...</div>;

    return menu;
  };

  return (
    <AppDrawer
      open={open}
      onClose={handleClose}
      headerTitle="Invite User"
      headerOptions={
        <Button
          color="primary"
          size="sm"
          onClick={handleInviteUser}
          disabled={addingUser || !permission || !userID}
          style={{ width: 70 }}
        >
          {addingUser ? (
            <AppSpinner color="white" style={{ height: 18, width: 18 }} />
          ) : (
            "Invite"
          )}
        </Button>
      }
      body={
        <>
          {addPageUserError && (
            <Alert className="mb-4" color="danger">
              {addPageUserError}
            </Alert>
          )}
          <FormGroup>
            <h4 className="mb-2">Invite Member</h4>
            <SelectPicker
              placeholder="Invite user to workspace"
              block
              value={userID}
              data={
                users
                  ?.filter((person) => !pageMembers.includes(person?.id))
                  ?.map((person) => ({
                    label: (
                      <>
                        <p
                          className="m-0"
                          style={{ fontSize: "14px", lineHeight: 1 }}
                        >
                          {person?.Name || person?.PrimaryContactEmail}
                        </p>
                        <small style={{ fontSize: "10px", lineHeight: 1 }}>
                          {person?.Name
                            ? person?.PrimaryContactEmail
                            : "Pending Invitation"}
                        </small>
                      </>
                    ),
                    value: person?.id,
                  })) ?? []
              }
              onChange={handleUserChange}
              renderMenu={renderMenu}
            />
          </FormGroup>
          <h4>Permissions</h4>
          <PermissionList
            permissions={permissions}
            onChange={setPermission}
            selectedPermission={permission}
            filterOwner
          />
        </>
      }
    />
  );
};

export default InvitePageUserDrawer;
